export enum ApprovalPrivilegeEnum {
  NONE = '0', // 権限なし
  APPROVER = '1', // 承認者
}

export const ApprovalPrivilege = [
  { label: '権限なし', value: ApprovalPrivilegeEnum.NONE },
  { label: '承認者', value: ApprovalPrivilegeEnum.APPROVER },
];
